import { APP_NAME } from '@verso/shared/src/constants/app'

// Hero copy variants for the landing A/B test (PostHog flag
// `landing-hero-variant`, resolved by `lib/experiments.ts#useLandingHeroVariant`).
//
// This is DATA, not JSX, so the whole hero can be driven off one map lookup
// instead of variant conditionals sprinkled through Landing.tsx. The h1 is
// modelled as: a `lead` line (optionally rotating) + an optional `tail` line
// whose middle word is brass-accented.

export type LandingHeroVariant = 'control' | 'reel-first'

export interface LandingHeroCopy {
  /**
   * First h1 line. When `rotate` is true these cycle in place; otherwise only
   * `lead[0]` is ever shown.
   */
  lead: string[]
  rotate: boolean
  /**
   * Second h1 line, rendered after a line break. Split so the accented word can
   * carry the brass colour. `null` = single-line headline.
   */
  tail: { before: string; brass: string; after: string } | null
  /** Sub-headline under the h1. */
  sub: string
}

export const LANDING_HERO_VARIANTS: Record<LandingHeroVariant, LandingHeroCopy> = {
  control: {
    lead: [
      'Long weekend coming up?',
      'Anniversary on the calendar?',
      'Honeymoon being planned?',
      'A week with the family?',
    ],
    rotate: true,
    tail: { before: 'Ask ', brass: APP_NAME, after: '.' },
    sub: 'Keep the places in your travel reels together. Build a trip from the ideas you already love.',
  },
  'reel-first': {
    lead: ['Save the reel. Keep the places.'],
    rotate: false,
    tail: null,
    sub: `Share a travel reel with ${APP_NAME}. Find its places in your collections, ready for your next trip.`,
  },
}

/**
 * The variant whose copy reserves hero layout while the flag is still resolving
 * (and the variant every fallback path lands on).
 */
export const DEFAULT_LANDING_HERO_VARIANT: LandingHeroVariant = 'reel-first'
